"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/team-section.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-one.jpg" | "/Templates/Doccure/img/team/team-img-two.jpg" | "/Templates/Doccure/img/team/team-img-three.jpg" | "/Templates/Doccure/img/team/team-img-four.jpg" */
    src: string;
    /** Detected variants: "Dr. Anthony Perez" | "Dr. Olivia Martinez" | "Dr. Karen Perez" | "Dr. Tyler Morgan" */
    link0Text: ReactNode;
    /** Detected variants: "Macular Degeneration Expert" | "Retina Surgeon" | "Glaucoma Specialist" | "Vision Therapy Specialist" */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-3 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "team-item-eight wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "0.5s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "team-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "team-img" */
    alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "team-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "team-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
};
export type HomeEightTeamSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection366sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection366sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection366sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "Explore Team Of" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "banner-icon" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-six-img3.jpg" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Expert Doctors" */
    sectionDiv0Div0H20Span1SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "all_routes.doctorsGrid" */
    sectionDiv0Div2Link0LinkHref?: string;
    /** Default: "View All Doctors" */
    sectionDiv0Div2Link0LinkText?: ReactNode;
    sectionDiv0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    teamSection366s: TeamSection366sItem[];
    teamSection366sItemWrapper?: (item: TeamSection366sItem, content: ReactNode) => ReactNode;
    teamSection366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection366sLinkVisible?: boolean;
    teamSection366sLinkRenderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sImageVisible?: boolean;
    teamSection366sImageRenderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sH3Visible?: boolean;
    teamSection366sH3Renderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection366sItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSection366sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection366sH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection366sItem) => Partial<ComponentProps<"h3">>);
};

const HomeEightTeamSectionGenerated: FC<HomeEightTeamSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Explore Team Of",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt = "banner-icon",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-six-img3.jpg",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20Span1SpanText = "Expert Doctors",
    sectionDiv0Div2Link0LinkHref = "all_routes.doctorsGrid",
    sectionDiv0Div2Link0LinkText = "View All Doctors",
    sectionDiv0Div2Link0LinkVisible,
    sectionDiv0Div2Link0LinkRenderer,
    sectionDiv0Div2Link0LinkProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    teamSection366s,
    teamSection366sItemWrapper,
    teamSection366sRenderer,
    teamSection366sLinkVisible,
    teamSection366sLinkRenderer,
    teamSection366sImageVisible,
    teamSection366sImageRenderer,
    teamSection366sH3Visible,
    teamSection366sH3Renderer,
    teamSection366sLinkProps,
    teamSection366sImageProps,
    teamSection366sH3Props,
}) => {
    return (
        <section className="team-section-eight section wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="container">
                <div className="section-header section-header-eight text-center">
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            {" "}
                            <span className="img-container">
                                {renderNode(sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </span>
                            <span className="text-gradient">{sectionDiv0Div0H20Span1SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        teamSection366s,
                        (item: TeamSection366sItem) => (
                            <div className={item.className ?? "col-lg-3 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-eight wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"} data-wow-delay={item.dataWowDelay ?? "0.5s"}>
                                    <div className={item.div0ClassName2 ?? "team-overlay"}>
                                        {renderItemNode(teamSection366sImageVisible, teamSection366sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "team-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one"} {...(typeof teamSection366sImageProps === "function" ? teamSection366sImageProps(item) : (teamSection366sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        {renderItemNode(teamSection366sLinkVisible, teamSection366sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "team-icon"} {...(typeof teamSection366sLinkProps === "function" ? teamSection366sLinkProps(item) : (teamSection366sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "team-content"}>
                                        {renderItemNode(teamSection366sH3Visible, teamSection366sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof teamSection366sH3Props === "function" ? teamSection366sH3Props(item) : (teamSection366sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(teamSection366sLinkVisible, teamSection366sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "#"} {...(typeof teamSection366sLinkProps === "function" ? teamSection366sLinkProps(item) : (teamSection366sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection366sItemWrapper,
                        teamSection366sRenderer
                    )}
                </div>
                <div className="view-all text-center">
                    {renderNode(sectionDiv0Div2Link0LinkVisible, sectionDiv0Div2Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div2Link0LinkHref} className="btn btn-primary theme-8-btn" {...(sectionDiv0Div2Link0LinkProps ?? {})}>
                            <span className="icon">
                                <i className="isax isax-arrow-right-3" />
                            </span>
                            {sectionDiv0Div2Link0LinkText}
                        </SmartLink>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeEightTeamSectionGenerated;
